/********** 検索ウィジェットの余白調整 **********/
(function () {
  const SUBMENU_SELECTOR = '.submenu-item';
  const ITEM_SELECTOR = '.mobile-facets__item';

  // 行頭にスペーサーを入れたいindex
  const BREAK_INDEXES = [5, 11, 16, 20, 26, 28];

  function insertSpacers() {
    const submenu = document.querySelector(SUBMENU_SELECTOR);
    if (!submenu) return;

    // 既存のスペーサーを全削除
    submenu.querySelectorAll('.facet-spacer').forEach(e => e.remove());

    // アイテムリストを取得
    const items = Array.from(submenu.querySelectorAll(ITEM_SELECTOR));

    // BREAK_INDEXESの番号に該当するアイテムが「表示中」なら、その直前にスペーサー挿入
    BREAK_INDEXES.forEach(index => {
      const item = submenu.querySelector(`.js-item-index-${index}`);
      if (item && item.offsetParent !== null) {
        const spacer = document.createElement('li');
        spacer.className = 'facet-spacer';
        item.parentNode.insertBefore(spacer, item);
      }
    });
  }

  // 初期描画＆facets.jsによる再描画時に呼ぶ
  document.addEventListener('DOMContentLoaded', insertSpacers);

  // スピナーの hidden クラス切り替わりを監視
  const spinner = document.querySelector('.facets_productCount .loading__spinner');
  if (spinner) {
    const observer = new MutationObserver(() => {
      if (spinner.classList.contains('hidden')) {
        // hiddenクラスが付いた＝ロード完了
        insertSpacers();
      }
    });
    observer.observe(spinner, {attributes: true, attributeFilter: ['class']});
  }
})();